<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['view_fees_payment'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="my-2">
                <div class="row">
                  <b-form-group class="col-md-3" label="Term">
                    <v-select
                      :options="schoolterms"
                      placeholder="Select Term"
                      v-model="schoolterm"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-2" label="Year">
                    <v-select
                      :options="years"
                      placeholder="Select Year"
                      v-model="year"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <b-form-group class="col-md-3" label="Class">
                    <v-select
                      :options="schoolclasses"
                      placeholder="Select Class"
                      v-model="schoolclass"
                      label="name"
                    ></v-select>
                  </b-form-group>
                  <div class="col-md-1 mt-md-4 mt-2 p-lg-0">
                    <b-button variant="primary" @click="FilterData()"
                      ><i class="mdi mdi-account-search"></i> Filter</b-button
                    >
                  </div>
                  <div class="col mt-4 mb-4 justify-content-end d-flex">
                    <router-link
                      :to="{
                        path: '/printfeesdefaulters',
                        query: {
                          term: schoolterm ? schoolterm.id : '',
                          term_name: schoolterm ? schoolterm.name : '',
                          year: year,
                          class: schoolclass ? schoolclass.id : '',
                          class_name: schoolclass ? schoolclass.name : '',
                        },
                      }"
                    >
                      <b-button class="mx-5" size="lg" variant="success"
                        >PRINT LIST</b-button
                      ></router-link
                    >
                  </div>
                </div>
              </div>
              <div class="clearfix"></div>
              <!-- <div class="text-center mt-4" v-if="schoolstream != ''">
                 <h3>{{ year }} - {{ schoolterm.name }} Fees Defaulters</h3>
              </div> -->
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Selected Yet</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(student_id)="data">
                    <b class="text-danger">{{
                      data.item.student.student_id
                    }}</b>
                    <br />
                  </template>
                  <template #cell(student)="data">
                    {{ data.item.student.first_name }}
                    {{ data.item.student.last_name }} <br />
                    <small
                      ><b>{{ data.item.student.student_id }}</b></small
                    >
                  </template>
                  <template #cell(stream)="data">
                    {{ data.item.stream.name }}
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view the Dashboard.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  schooltermComputed,
  schooltermMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Fees Payments",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Fees Defaulters",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Fees Defaulters", active: true },
      ],

      currentdate: new Date().toLocaleDateString("fr-CA"),
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,

      fields: [
        { key: "index", label: "#", visible: true },
        { key: "student", label: "Student", visible: true },
        { key: "stream", label: "Stream", visible: true },
        { key: "balance", label: "Fees Balance", visible: true },
      ],
      userData: JSON.parse(localStorage.getItem("user")),
      id: "",
      student: "",
      year: "",
      term: "",
      name: "",
      student_id: "",
      schoolterm: "",
      schoolclass: "",
      stream: "",
      amount: 0,
      feesdefaulters: [],
    };
  },
  computed: {
    ...schoolclassComputed,
    ...schooltermComputed,
    List() {
      return this.feesdefaulters.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.feesdefaulters.map((d) => ({ ...d }));
    },
    IsBusy() {
      return this.feesdefaulters.length === 0;
    },
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {
        yearArray.push(year);
      }
      return yearArray;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchSchoolTerms();
    this.TotalRows = this.feesdefaulters.length;
    this.isBusy = false;
  },
  methods: {
    ...schoolclassMethods,
    ...schooltermMethods,

    commas(x) {
      if (x == null || x == undefined) return "0";
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    async FilterData() {
      let formData = new FormData();
      formData.append("term", this.schoolterm.id);
      formData.append("year", this.year);
      formData.append("class", this.schoolclass.id);
      let url = "/defaulters";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.feesdefaulters = response.data.feesdefaulters;
          this.TotalRows = this.feesdefaulters.length;
        }
      });
    },
  },
};
</script>
